/**
 * Created by andrey on 09.02.2021.
 */

const DecoratorUnits = function () {
    cleverapps.EventEmitter.call(this);

    const targetBundles = [
        Map2d.getTilesTexture(Map2d.currentMap.tilesSkin),
        Map2d.getUnitsTexture(Map2d.currentMap.unitsSkin)
    ];

    const codes = Object.keys(bundles).filter((name) => name.indexOf("decorator_") === 0 && cleverapps.intersect(bundles[name].injectTo, targetBundles).length).map((name) => name.slice(10));

    this.units = codes.map((code) => new DecoratorUnit({
        code
    }));

    const terrains = [];

    Object.values(Map2d.TERRAINS).forEach((terrain) => {
        const bundle = `${Map2d.getTilesTexture(Map2d.currentMap.tilesSkin)}_${terrain}`;

        if (!bundles[bundle]) {
            return;
        }

        for (const frame in bundles[bundle].frames) {
            terrains.push(`${bundle}#${frame}`);
        }
    });

    this.terrains = terrains.map((code) => new DecoratorUnit({
        code
    }));
};

DecoratorUnits.prototype = Object.create(cleverapps.EventEmitter.prototype);
DecoratorUnits.prototype.constructor = DecoratorUnits;

DecoratorUnits.prototype.getUnits = function (options) {
    switch (options && options.type) {
        case DecoratorUnits.TYPE_TERRAIN:
            return this.terrains;
        default:
            return this.units;
    }
};

DecoratorUnits.prototype.getUnitIcons = function (options) {
    return this.getUnits(options).map((unit) => new DecoratorUnitIcon(unit));
};

DecoratorUnits.TYPE_DECORATOR = "decorator";
DecoratorUnits.TYPE_TERRAIN = "terrain";
